import m from 'mithril'

export default m.trust(`
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M15 11C15 13.2091 13.2091 15 11 15C8.79086 15 7 13.2091 7 11C7 8.79086 8.79086 7 11 7C13.2091 7 15 8.79086 15 11ZM14.0002 15.0002C13.1645 15.628 12.1257 16 11 16C8.23858 16 6 13.7614 6 11C6 8.23858 8.23858 6 11 6C13.7614 6 16 8.23858 16 11C16 12.2753 15.5225 13.4391 14.7366 14.3224L15.0607 14.6464L17.7054 17.2912L18.059 17.6448L17.3519 18.3519L16.9983 17.9983L14.3536 15.3536L14.0002 15.0002Z" fill="white" fill-opacity="0.4"/>
	</svg>
`)